module.exports = __webpack_public_path__ + "img/og-image.033a0727.jpg";